 export default function SpaceHandler() {
    const spaces = document.querySelectorAll('[data-space-menu]');

    if (spaces) {
        spaces.forEach((el) => {
            el.addEventListener('click', () => {
                const openSpaceMenu = document.querySelector('[data-space-menu].active');
                
                if (openSpaceMenu === el) return;
                
                const openSpace = document.querySelector('[data-space-content].active');

                openSpaceMenu.classList.remove('active');
                if (openSpace) openSpace.classList.remove('active');

                const nextSpace = document.querySelector(`[data-space-content="${el.dataset.spaceMenu}"]`);
                
                el.classList.add('active');
                nextSpace.classList.add('active');
            });
        });
    }
}
  